import Http from '@/utils/request'
import type {
  CartoonFollowRes,
  CartoonInfoRes,
  CartoonWorkRes,
} from './type'

export function fetchCartoonInfo(cartoonId: string): Promise<CartoonInfoRes> {
  return Http({
    url: `/pipe/cartoon/${cartoonId}`,
    method: 'get',
  })
}

export function fetchCartoonWorks(
  cartoonId: string,
  obj: string,
  pageNo: number,
): Promise<CartoonWorkRes> {
  return Http({
    url: `/cartoon/work/${cartoonId}`,
    method: 'get',
    params: {
      obj,
      pageNo: pageNo >= 1 ? pageNo : 1,
    },
  })
}

export function fetchCartoonAppearances(
  cartoonId: string,
  pageNo: number,
): Promise<CartoonWorkRes> {
  return Http({
    url: `/cartoon/appearance/${cartoonId}`,
    method: 'get',
    params: {
      pageNo: pageNo >= 1 ? pageNo : 1,
    },
  })
}

export function followCartoon(cartoonId: string): Promise<CartoonFollowRes> {
  return Http({
    url: `/cartoon/follow/${cartoonId}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

export function unfollowCartoon(cartoonId: string): Promise<CartoonFollowRes> {
  return Http({
    url: `/cartoon/unfollow/${cartoonId}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}
